import { Component, inject, output, ChangeDetectionStrategy } from '@angular/core';

import { TooltipModule } from 'primeng/tooltip';
import { HelpService } from '@web/csl-lib-services';

@Component({
  selector: 'csl-help-button',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './help-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './help-button.component.css',
})
export class HelpButtonComponent {
  onClick = output<void>();

  /* Store */




  /* Services */




  /* Member Vars */

  // Necessary for the onClick callback to be called
  readonly helpService = inject(HelpService);


  /* Lifecycle Hooks */




  /* Event Handlers */

  onHelpButtonClicked() {
    this.onClick.emit();
  }


  /* Instance Methods */



}
